import { Component, effect } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RichTextEditorComponent } from '@/global/rich-text-editor.component';
import { ExemptionService } from '@/services/api/exemption.service';
import { BinderDialogService } from '@/services/app/binder-dialog.service';
import { BinderService } from '@/services/api/binder.service';

@Component({
    selector: 'app-request',
    imports: [CommonModule,RichTextEditorComponent,ButtonModule,FormsModule],
    template: `
    <div class="flex gap-5 flex-column-reverse md:flex-row">
    <div class="flex-auto p-fluid">
        <div class="mb-4">
            <div class="text-900 font-medium mb-2 text-xl">What is this for?</div>
    <p class="mt-0 mb-4 p-0 line-height-3">In cases where the new contract structure isnt feasible, you can request an exemption. This requires approval from Lexar corporate, usually from the general manager (GM), or other administrators. These request will be considered carefully are not guarenteed to be approved. For further assistance or to find out if this binder qualifies for excemption, please contact the Lexar corporate office.</p>
        </div>
        <div class="mb-4">
            <label for="bio" class="block font-medium text-900 mb-2">Request Message</label>
    <app-rich-text-editor [(ngModel)]="message" [style]="{ height: '320px' }"></app-rich-text-editor>
        </div>
</div>
</div>
<div class="surface-card d-flex text-black footer-buttons border-round">
<div class="info-action-row">
  <div class="info ml-2 md:mr-2">
  </div>
  <div class="action-row" >
    <div  class="action-item">
      <p-button icon="pi pi-check" 
      [rounded]="false" 
      [label]="'Request Exemption'" 
      (click)="onRequest()"
      [disabled]="!message">
    </p-button>
    </div>
  </div>
</div>
</div>
    `,
})
export class ExRequestComponent {
  message: string = '';
  binderId: number = 0;
  clientName:string='';
  binderModelSubscription!: Subscription;

  constructor(
    private exemptionService: ExemptionService, 
    private binderDialogService: BinderDialogService, 
    private messageService: MessageService,
    private currentBinderService: BinderService
  ) {
    effect(() => {
      const binder = this.currentBinderService.currentBinder();
      if (binder) {
        this.binderId = binder.BinderID;
        this.clientName = binder.ClientLastName;
      }
    });
  }

  onRequest() {
    this.binderDialogService.closeDialog(false);
    this.exemptionService.requestExemption(this.message, this.binderId, this.clientName).subscribe((res: any) => {
      this.messageService.add({severity:'success', summary:'Success', detail:'Exemption request sent'});
      this.currentBinderService.patchBinder({exPending: true});
    });
  }

}